/**
 * WordPress dependencies
 */
import { registerBlockType } from '@wordpress/blocks';
import { createBlock } from '@wordpress/blocks';

/**
 * Internal dependencies
 */
import Edit from './edit';

/**
 * Register the Arrow Link Block
 */
registerBlockType('puroclean/arrow-link', {
  edit: Edit,
  // No save function needed - this is a dynamic block
  transforms: {
    from: [
      {
        type: 'prefix',
        prefix: 'arrow:',
        transform: () => {
          return createBlock('puroclean/arrow-link', {
            text: 'Learn More',
            url: '#'
          });
        }
      }
    ]
  }
});
